interface RowActionsProps {
  onEdit?: () => void;
  onDelete?: () => void;
}

export default function RowActions({ onEdit, onDelete }: RowActionsProps) {
  return (
    <div className="flex items-center justify-end gap-0.5" onClick={(e) => e.stopPropagation()}>
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          title="Düzenle"
          className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-background-100 hover:text-primary-700"
        >
          <i className="ri-edit-2-line" />
        </button>
      )}
      {onDelete && (
        <button
          type="button"
          onClick={onDelete}
          title="Sil"
          className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-accent-100 hover:text-accent-700"
        >
          <i className="ri-delete-bin-6-line" />
        </button>
      )}
    </div>
  );
}